module.exports = __webpack_public_path__ + "2c06297c0aa5b25fa33d39d1b457c18c.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/kulturhaus-pusdorf.svg
// module id = 952
// module chunks = 0